export class DataverseEntityMissingError extends Error {
  constructor(entityLogicalName) {
    super(
      `Tabellen «${entityLogicalName}» finnes ikke i dette Dataverse-miljøet. Importer OpenCare-løsningen.`
    );
    this.name = 'DataverseEntityMissingError';
    this.entityLogicalName = entityLogicalName;
  }
}

export function isDataverseEntityMissingError(error) {
  return error instanceof DataverseEntityMissingError;
}

function getEntitySetFromEndpoint(endpoint) {
  const match = endpoint.match(/^\/(oc_[a-z0-9_]+)/i);
  return match ? match[1] : null;
}

/** True when a 404 on a collection GET means the table is absent from the environment. */
export function isEntitySetMissingResponse(endpoint, method, status) {
  if (status !== 404 || (method || 'GET').toUpperCase() !== 'GET') {
    return false;
  }

  const path = endpoint.split('?')[0];
  return /^\/oc_(locks|innbyggers)$/i.test(path);
}

export function throwIfEntitySetMissing(endpoint, method, status) {
  if (!isEntitySetMissingResponse(endpoint, method, status)) {
    return;
  }

  const entitySet = getEntitySetFromEndpoint(endpoint);
  const logicalName = entitySet === 'oc_locks' ? 'oc_lock' : 'oc_innbygger';
  throw new DataverseEntityMissingError(logicalName);
}
